let navigateFunction = null;

export const setNavigate = (navigate) => {
  navigateFunction = navigate;
};

export const getNavigate = () => navigateFunction;

export const getUrlVars = () => {
  const vars = {};
  window.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    function (m, key, value) {
      vars[key] = value;
    },
  );
  return vars;
};

export const getUrlParam = (parameter, defaultvalue) => {
  let urlparameter = defaultvalue;
  if (window.location.href.indexOf(parameter) > -1) {
    urlparameter = getUrlVars()[parameter];
  }
  return urlparameter;
};

const isValidPath = (path) => {
  if (!path || typeof path !== 'string') return false;
  // Only allow relative paths starting with /
  return path.startsWith('/') && !path.startsWith('//');
};

export const routeHandler = (path) => {
  if (!isValidPath(path)) return;

  const search = window.location.search;

  const navigate = (url) => {
    if (navigateFunction) {
      navigateFunction(url);
    } else {
      window.location.href = url;
    }
  };

  navigate(path + search);
};

export const createRouteHandler = (navigate) => (path) => {
  if (!isValidPath(path)) return;
  const search = window.location.search;
  navigate(path + search);
};
